/**
 * Azure storefront API helper (picking-store/slot split).
 * Prefer storefrontApiURL; fall back to legacy deliveryURL JSONP on CORS/network/HTTP failure.
 */
(function () {
  function azureGet(path, params) {
    var qs = params ? ('?' + new URLSearchParams(params).toString()) : '';
    var base = (typeof storefrontApiURL !== 'undefined' && storefrontApiURL) || '';
    if (!base) return Promise.reject(new Error('storefrontApiURL missing'));
    // These endpoints are reads. Bound headers AND body so a stalled Azure
    // connection can reach the existing legacy fallback. Do not time out or
    // retry an unknown endpoint which might submit a reservation.
    var readOnly = /^(storefront\/(click-and-collect-stores|state-filter|delivery-pass-status|customer-frequency|customer-gold-status|calculate-delivery))$/.test(path);
    var controller = readOnly && typeof AbortController === 'function' ? new AbortController() : null;
    var timer;
    var request = fetch(base + path + qs, {
      headers: { Accept: 'application/json' },
      ...(controller ? { signal: controller.signal } : {})
    })
      .then(function (res) {
        if (!res.ok) throw new Error(path + ' responded ' + res.status);
        return res.json();
      });
    if (!readOnly) return request;
    var deadline = new Promise(function (resolve, reject) {
      timer = setTimeout(function () {
        reject(new Error(path + ' timed out after 15 seconds'));
        if (controller) controller.abort();
      }, 15000);
    });
    return Promise.race([request, deadline]).finally(function () { clearTimeout(timer); });
  }

  function getOrLegacy(path, params, legacyUrl) {
    return azureGet(path, params).catch(function (err) {
      console.warn('StorefrontApi: Azure unavailable for ' + path + ', falling back to legacy:', err);
      if (typeof fetchJSONP !== 'function') return Promise.reject(err);
      return fetchJSONP(legacyUrl, 'c');
    });
  }

  window.StorefrontApi = { get: azureGet, getOrLegacy: getOrLegacy };
})();
